import featuredCreators from '@/store/modules/homepage/featured-creators';
import featuredContent from '@/store/modules/homepage/featured-content';
import superfeaturedUsers from '@/store/modules/homepage/superfeatured';

export default {
  namespaced: true,
  modules: {
    featuredCreators,
    featuredContent,
    superfeaturedUsers,
  },
};
